import { compose, filter, sortBy } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getStringProp, getStringArrayProp, getProp } from '@mews/fp';
import { DateTimeUtcService, useLocalizeProperty } from '@mews/framework';
import { RouteName } from '@mews-commander/enums';
import { ResolveRoute } from '@mews/routing';
import { getAppNowUtcProp } from '@mews-commander/utils';
import { getCurrentEnterpriseEditableHistoryIntervalMilliseconds } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { mapProductOptions } from '@mews-commander/legacy-entities/src/utils/mapProductOptions';

export const getProductOptions = (
    isMultiTaxEnvironment: $TSFixMe,
    prices: $TSFixMe,
    localizeProperty: ReturnType<typeof useLocalizeProperty>
) =>
    compose(
        mapProductOptions(isMultiTaxEnvironment, prices, localizeProperty),
        sortBy('ordering'),
        filter('options.offerToEmployee')
    );

export const getMinEditableUtc = createSelector(
    getAppNowUtcProp,
    getCurrentEnterpriseEditableHistoryIntervalMilliseconds,
    (appNowUtc, editableHistoryIntervalMillies) => {
        const editableHistoryIntervalSeconds = (editableHistoryIntervalMillies as $TSFixMe) / 1000;

        const { value } = DateTimeUtcService.addSeconds(appNowUtc, -editableHistoryIntervalSeconds);
        return value;
    }
);

export const getBillDetailUrl = createSelector(
    getProp<ResolveRoute>()('resolveRoute'),
    getStringProp('id'),
    (resolveRoute, id) => resolveRoute(RouteName.BillDetail, { id })
);

export const getReservationMembershipFileUrl = createSelector(
    getProp<ResolveRoute>()('resolveRoute'),
    getStringProp('groupId'),
    (resolveRoute, groupId) =>
        resolveRoute(RouteName.ReservationMembershipExport, { groupId, query: { Layout: 'Empty' } })
);

export const getRegistrationCardUrl = createSelector(
    getProp<ResolveRoute>()('resolveRoute'),
    getStringArrayProp('reservationIds'),
    (resolveRoute, reservationIds) =>
        resolveRoute(RouteName.CustomerReservationRegistrationCards, {
            query: { ReservationIds: reservationIds, ForPrint: 'True' },
        })
);

export * from './reservationModuleState';
export * from './summary';
export * from './dateGroups';
